import { useState, useEffect } from 'react';

const readDarkMode = () =>
  typeof window !== 'undefined' && window.localStorage.getItem('darkMode') === 'true';

/**
 * Dark-mode state that stays in sync with DashboardLayout without polling.
 * DashboardLayout dispatches a `darkModeChange` window event on toggle;
 * cross-tab toggles arrive via the native `storage` event.
 */
export default function useDarkMode() {
  const [isDarkMode, setIsDarkMode] = useState(readDarkMode);

  useEffect(() => {
    const sync = () => setIsDarkMode(readDarkMode());
    window.addEventListener('storage', sync);
    window.addEventListener('darkModeChange', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('darkModeChange', sync);
    };
  }, []);

  return isDarkMode;
}
